<template>
	<div class="container">
		<div class="footer_box">
			<div class="footer_main">
				<div class="left">
					<div
						class="logo"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
						@click="goHome"
					>
						<img src="../../assets/img/logo.png" />
					</div>
					<div
						class="title"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>FOLLOW US</div>
					<div
						class="link_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<img v-for="(value, index) in linkList" :key="value.imgUrl" class="link_el" :src="value.imgUrl" @click="goLink(value)" />
					</div>
				</div>
				<div
					class="right"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="txt_box">
						<div class="tit" @click="goHome">HOME</div>
						<div v-for="(value, index) in navList" :key="index" class="txt" @click="goNav(value)">{{ value.title }}</div>
					</div>
					<div class="txt_box">
						<div class="tit" @click="goNav2">PRODUCTS</div>
						<div v-for="(value, index) in productType" :key="index" class="txt" @click="goProducts(value)">{{ initStr(value.title) }}</div>
						<div class="txt" @click="goIm">I-MEMBRANE</div>
					</div>
					<!-- <div class="txt_box">
						<div class="tit" @click="goServices">SERVICES</div>
						<div v-for="(value, index) in servicesList" :key="index" class="txt" @click="goServices">{{ initStr(value.name) }}</div>
					</div> -->
				</div>
			</div>
			<div class="msg">Copyright {{ yearData }}, UC reagent, Inc. All rights reserved.</div>
		</div>
	</div>
</template>

<script>
// import { submitMsg } from '@/api/public';  //提交留言
import moment from 'moment';
export default {
	components:{
		//
	},
	data() {
		return {
			linkList: [
				{ imgUrl: require('@/assets/img/footer/icon_1.webp'), link: 'https://www.linkedin.com/company/jtests/' },
				// { imgUrl: require('@/assets/img/footer/icon_2.webp'), link: '' },
				{ imgUrl: require('@/assets/img/footer/icon_3.webp'), link: 'https://x.com/JtestsBiotech' },
				{ imgUrl: require('@/assets/img/footer/icon_4.webp'), link: 'https://www.instagram.com/jtestsbiotech/' }
				// { imgUrl: require('@/assets/img/footer/icon_5.webp'), link: '' }
			],
			navList: [
				{ title: 'ABOUT', route: '/about' },
				{ title: 'NEWS', route: '/news' },
				// { title: 'CAREERS', route: '/careers' },
				{ title: 'CONTACT', route: '/contact' }
			],
			productType: [],
			servicesList: [],
			yearData: null
		}
	},
	created(){
		let that = this;
		if(sessionStorage.getItem('navData')) {
			that.productType = JSON.parse(sessionStorage.getItem('navData')).cate_list;
			that.servicesList = JSON.parse(sessionStorage.getItem('navData')).service_list;
		}
		that.yearData = moment().format('YYYY');
	},
	mounted() {
		let that = this;
	},
	methods: {
		initStr(value) {
			return value.toUpperCase();
		},
		//跳转服务
		goServices() {
			let that = this;
			if(that.$route.path != '/services') {
				that.$router.push({ path: '/services' });
			}else {
				window.location.reload();
			}
		},
		//跳转产品
		goProducts(value) {
			let that = this;
			if(that.$route.path != '/products') {
				that.$router.push({ path: '/products', query: { type: value.id } });
			}else {
				that.$router.push({ path: '/products', query: { type: value.id } });
				window.location.reload();
			}
		},
		goNav2() {
			let that = this;
			if(that.$route.path != '/products') {
				that.$router.push({ path: '/products' });
			}else {
				that.$router.push({ path: '/products' });
				setTimeout(() => {
					window.location.reload();
				}, 300);
			}
		},
		//导航点击
		goNav(value) {
			let that = this;
			if(value.route != '/careers') {
				if(that.$route.path != value.route) {
					that.$router.push({ path: value.route });
				}else {
					window.location.reload();
				}
			}else {
				window.open('https://cordx.com/careers');
			}
		},
		goIm() {
			window.open('https://i-membrane.com/');
		},
		//跳转外链
		goLink(value) {
			if(value.link) {
				window.open(value.link);
			}
		},
		//点击首页
		goHome() {
			if(this.$route.path != '/') {
				this.$router.push({ path: '/' });
			}else {
				window.location.reload();
			}
		}
	}
}
</script>

<style lang="less" scoped>
.footer_box{
	width: 100%;
	max-width: 1920px;
	margin: 0 auto;
	background-color: #F6F6F6;
	border-top: 1px solid #D9D9D9;
	.msg{
		width: 1140px;
		margin: 0 auto;
		padding: 0px 0 30px 0;
		color: #999999;
	}
	.footer_main{
		display: flex;
		width: 1140px;
		margin: 0 auto;
		padding: 40px 0 40px 0;
		color: #000000;
		.right{
			flex: 1;
			display: flex;
			.txt_box:last-child{
				padding-right: 0;
			}
			.txt_box:first-child{
				padding-left: 0;
			}
			.txt_box{
				padding: 0 45px;
				.txt:hover{
					color: #E37542;
					text-decoration: underline;
					font-style: italic;
				}
				.txt{
					padding-top: 10px;
					cursor: pointer;
				}
				.tit:hover{
					color: #E37542;
					text-decoration: underline;
					font-style: italic;
				}
				.tit{
					font-size: 16px;
					font-weight: bold;
					cursor: pointer;
				}
			}
		}
		.left{
			flex: 1;
			.link_box{
				.link_el:hover{
					transform: scale(1.2);
				}
				.link_el{
					display: inline-block;
					height: 30px;
					margin-right: 15px;
					cursor: pointer;
					transition: all 0.2s;
				}
			}
			.title{
				padding-top: 70px;
				font-size: 16px;
			}
			.logo{
				img{
					// width: 120px;
					height: 40px;
					cursor: pointer;
				}
			}
		}
	}
}
</style>